import React from 'react';
import { AnimatedCTA3D } from './AnimatedCTA3D';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section relative h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/hero-background.webp')`,
        }}
      >
        {/* Overlay noir 20% pour contraste WCAG */}
        <div className="absolute inset-0 bg-black/20"></div>
      </div>
      
      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto space-y-8 animate-fade-in backdrop-blur-sm bg-white/5 p-12 rounded-lg"
             style={{ backdropFilter: 'blur(2px)' }}>
          <div className="inline-block">
            <div className="h-[1px] w-16 bg-gold mx-auto mb-6"></div>
          </div>
          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-playfair font-bold text-white leading-tight tracking-tight">
            L'Art de la <span className="text-gold italic">Précision</span>
          </h1>
          
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto tracking-wide leading-relaxed">
            Conseil, Dessin Technique & Agencement Intérieur de précision
          </p>
          
          <div className="pt-8">
            <AnimatedCTA3D 
              onClick={scrollToContact}
              text="Démarrer votre projet"
            />
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-gold/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-gold rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
